import React from 'react';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import CenteredModal from '../../Modules/Testimonials/Components/CenteredModal';
import { SpinnerNew as Spinner } from '~/App/Components/Shared/Spinner';
import cx from 'classnames';

export interface DeleteConfirmationModalProps {
  open: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  loading?: boolean;
  onConfirm: () => Promise<unknown>;
  confirmCtaText?: string;
  onCancel: () => void;
  cancelCtaText?: string;
  footer?: React.ReactNode;
  hideIcon?: boolean;
}

export default function DeleteConfirmationModal({
  open,
  title,
  subtitle,
  loading = false,
  onConfirm,
  confirmCtaText = 'Continue',
  onCancel,
  cancelCtaText = 'Cancel',
  footer,
  hideIcon = false,
}: DeleteConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <CenteredModal
      open={open}
      onRequestClose={onCancel}
      loading={loading}
      width={479}
      hideCloseButton
    >
      {!hideIcon && (
        <div className='flex justify-center'>
          <FontAwesomeIcon
            className='mb-[30px] v2-text-orange-700 flex mx-auto w-[44px] h-[50px]'
            icon={faTrash}
          />
        </div>
      )}
      <h2
        className={cx(
          'text-[21px] v2-text-neutral-900 font-bold text-center mt-0',
          {
            'mb-[30px]': !subtitle,
            'mb-[15px]': subtitle,
          }
        )}
      >
        {title}
      </h2>
      {subtitle && (
        <div className='text-base v2-text-neutral-900 text-center mb-[15px]'>
          {subtitle}
        </div>
      )}
      <div className='flex flex-col justify-center gap-y-3 md:flex-row md:gap-x-4'>
        <Button
          className='w-full md:w-auto text-base v2-text-neutral-900 !h-10 !py-1.5'
          variant='secondary'
          onClick={onCancel}
          disabled={loading}
        >
          {cancelCtaText}
        </Button>
        <Button
          className='w-full md:w-auto text-base !h-10 !py-1.5'
          variant='danger'
          onClick={handleConfirm}
          disabled={loading}
        >
          {confirmCtaText} {loading && <Spinner className='ml-2' />}
        </Button>
      </div>
      {footer && <div className='flex justify-center mt-5'>{footer}</div>}
    </CenteredModal>
  );
}
